export enum OrderDocumentType {
  AntecedentDocument = 1,
  Others = 2,
}

export const OrderDocumentTypeLabel: Record<OrderDocumentType, string> = {
  [OrderDocumentType.AntecedentDocument]: 'Informe/Certificado antecedente',
  [OrderDocumentType.Others]: 'Otros',
};
